export type PatronCategoryColor =
  'patron-category-default' | 'patron-category-1' | 'patron-category-2' | 'patron-category-3' | 'patron-category-4' | 'patron-category-5';

export const PatronCategoryColorConversions: Map<string, PatronCategoryColor> = new Map([
  ['#d84315', 'patron-category-default'],
  ['#1660a5', 'patron-category-1'],
  ['#4527a0', 'patron-category-2'],
  ['#00838f', 'patron-category-3'],
  ['#ad1457', 'patron-category-4'],
  ['#558b2f', 'patron-category-5'],
]);
